$('.js-quantity-field').on('change', function(){
  const value = $(this).val();

  $('.js-quantity-hidden-input').val(value);
});

$('.js-list-count a').on('click', function(){
  if ($('body').hasClass('template-product')) {
    const $this = $(this);

    setTimeout(function(){
      const value = $this.closest('.js-list-count').find('.js-quantity-field').val();

      $('.js-quantity-hidden-input').val(value);
    },50);
  }
});
